/*
export default function (link) {
    return new Promise((resolve, reject) => {
        let googleScript = document.querySelector(`script[src="${link}"]`);

        if (!googleScript) {
            googleScript = document.createElement('script');
            googleScript.src = link;
            googleScript.async = true;
            document.head.append(googleScript);

            googleScript.addEventListener('error', () => {
                reject();
            })
            
            googleScript.addEventListener('load', () => {
                resolve();
            })
        }
    });
}
*/
export default function (link) {
    return new Promise((resolve, reject) => {
        // 1. Aggiungiamo forzatamente loading=async all'URL se non c'è
        let finalLink = link;
        if (!finalLink.includes('loading=async')) {
            finalLink += (finalLink.includes('?') ? '&' : '?') + 'loading=async';
        }

        // 2. Usiamo una ricerca più solida per evitare duplicati
        // Cerchiamo uno script che contenga la tua API KEY (parte unica del link)
        const apiKeyMatch = link.match(/key=([^&]+)/);
        const selector = apiKeyMatch 
            ? `script[src*="key=${apiKeyMatch[1]}"]` 
            : `script[src^="${link.split('?')[0]}"]`;
            
        let googleScript = document.querySelector(selector);

        if (googleScript) {
            // Se esiste già, consideriamo la promessa risolta
            resolve();
            return;
        }

        // 3. Creazione del tag con i parametri corretti
        googleScript = document.createElement('script');
        googleScript.src = finalLink;
        googleScript.async = true;
        googleScript.defer = true;

        googleScript.addEventListener('load', () => resolve());
        googleScript.addEventListener('error', () => reject(new Error("Errore Google Maps")));

        document.head.append(googleScript);
    });
}